import { insightTypes } from "../actions/insight";

const initialState = {
  locations: [],
  tab1: {
    isLoading: false,
    data: {
      assets: [],
      reporting: {
        gatewayCount: 0,
        avgBattery: 0,
        percentageonline: 0,
      },
      reportingHistory: {
        date: [],
        gatewayCount: [],
        avgBattery: [],
      },
    },
    error: null,
  },
  tab2: {
    isLoading: false,
    filters: {
      startDate: "",
      endDate: "",
      assettype: "allassets",
    },
    data: [],
    error: null,
  },
};

const insightReducer = (state = initialState, action) => {
  switch (action.type) {
    case insightTypes.FETCH_TAB1_REQUEST:
      return {
        ...state,
        tab1: { ...state.tab1, isLoading: true },
      };
    case insightTypes.FETCH_TAB1_SUCCESS:
      return {
        ...state,
        locations: action.payload.locations,
        tab1: {
          ...state.tab1,
          isLoading: false,
          data: { ...state.tab1.data, ...action.payload.data },
        },
      };
    case insightTypes.FETCH_TAB1_FAILURE:
      return {
        ...state,
        tab1: {
          ...state.tab1,
          isLoading: false,
          error: action.payload,
        },
      };
    case insightTypes.FETCH_TAB2_REQUEST:
      return {
        ...state,
        tab2: {
          ...state.tab2,
          isLoading: true,
          filters: action.payload.filters ? action.payload.filters : state.tab2.filters,
        },
      };
    case insightTypes.FETCH_TAB2_SUCCESS:
      return {
        ...state,
        tab2: {
          ...state.tab2,
          isLoading: false,
          data: action.payload,
        },
      };
    case insightTypes.FETCH_TAB2_FAILURE:
      return {
        ...state,
        tab2: {
          ...state.tab2,
          isLoading: false,
          data: [],
          error: action.payload,
        },
      };
    case insightTypes.UPDATE_TAB2_FILTERS:
      return {
        ...state,
        tab2: {
          ...state.tab2,
          filters: {
            ...state.filters,
            ...action.payload,
          },
        },
      };
    default:
      return state;
  }
};

export default insightReducer;
